import React from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import { Route } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

export const RouteLink = withStyles((theme) => ({
  root: {
    color: theme.palette.primary.light,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  active: {
    color: theme.palette.primary.main,
    '&:visited': {
      color: theme.palette.primary.main,
    },
  },
}))(({ path, children, exact = true, className, classes, ...rest }) => (
  <Route path={path} exact={exact}>
    {({ match }) => {
      return (
        <Link
          className={classNames(
            classes.root,
            match && classes.active,
            className
          )}
          to={path}
          {...rest}
        >
          {children}
        </Link>
      );
    }}
  </Route>
));
